import React, { useState } from 'react';
import { Box, Button } from '@mui/material';

interface TimeButtonsProps {
  timeRanges: any[];
  duration: number;
  pickedDate: any;
  onClick: (value: string) => void;
}

const TimeButtons = ({
  timeRanges,
  duration,
  pickedDate,
  onClick,
}: TimeButtonsProps) => {
  const values: any[] = [];
  const [lastClickedIndex, setLastClickedIndex] = useState<number | null>(null);

  const currentDate = new Date();
  const currentHours = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();
  const currentTimeInMinutes = currentHours * 60 + currentMinutes;
  const pickedDateFormatted = pickedDate.format('YYYY-MM-DD').replace(/-/g, '/');
  const currentDateFormatted = currentDate.toISOString().split('T')[0].replace(/-/g, '/');

  if (!timeRanges || timeRanges.length < 1) {
    values.push("err");
  } else {
    timeRanges.forEach((timeRange) => {
      const { from, to } = timeRange || {};
      const startTime = from.hours * 60 + from.minutes;
      const endTime = to.hours * 60 + to.minutes;

      for (let intervalTime = startTime; intervalTime < endTime; intervalTime += duration) {
        const endTimeOfInterval = intervalTime + duration;

        if (endTimeOfInterval <= endTime) {
          const hours = Math.floor(intervalTime / 60);
          const minutes = intervalTime % 60;
          const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

          if (pickedDateFormatted === currentDateFormatted) {
            if (currentTimeInMinutes < hours * 60 + minutes ) {
              values.push(formattedTime);
            }
          } else {
            values.push(formattedTime);
          }
        }
      }
    });
  }

  const handleButtonClick = (value: string, index: number) => {
    setLastClickedIndex(index);
    onClick(value === "err" ? "" : value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        width: '100%',
        flexWrap: 'wrap',
      }}
    >
      {values.map((value, index) => (
        value === 'err' ?
          <Button
            disableRipple
            sx={{
              flex: '1 1 100%',
              maxWidth: '100%',
              marginBottom: '10px',
              borderRadius: '27px',
              background: 'transparent',
              border: '2px solid #F3F3F3',
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            There is no available hours
          </Button>
          :
          <Button
            disableRipple
            onClick={() => handleButtonClick(value, index)}
            key={value}
            variant="contained"
            color="primary"
            sx={{
              flex: '1 1 48.5%',
              maxWidth: '48.5%',
              marginBottom: '10px',
              borderRadius: '27px',
              background: 'transparent',
              border: '2px solid',
              borderColor: lastClickedIndex === index ? '#BF295C' : '#F3F3F3',
              boxShadow: 'none',
              color: 'black',
              '&:hover': {
                backgroundColor: '#FFF8FA',
                boxShadow: 'none',
                borderColor: '#BF295C',
              }
            }}
          >
            {value}
          </Button>
      ))}
    </Box>
  );
};

export default TimeButtons;
